import { useEffect } from 'react'
import { useBuildex } from '../useBuildex'
import { useTradex } from '../useTradex'
import { useHealthdex } from '../useHealthdex'

const useTheme = () => {
  const isBuildex = useBuildex()
  const isTradex = useTradex()
  const isHealthdex = useHealthdex()

  useEffect(() => {
    if (isBuildex) {
      document.documentElement.dataset.theme = 'buildex'
    } else if (isTradex) {
      document.documentElement.dataset.theme = 'tradex'
    } else if (isHealthdex) {
      document.documentElement.dataset.theme = 'healthdex'
    }
  }, [isBuildex, isTradex, isHealthdex])
}

export default useTheme
